import { Component, Input, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-image-container',
  templateUrl: './image-container.component.html',
  styleUrls: ['./image-container.component.scss'],
})
export class ImageContainerComponent {
  @Input() src!: string;
  @Input() customClass: string = '';
  @Input() enableZoom: boolean = true;
  @Input() alt: string = 'Image';

  constructor(private dialog: MatDialog) { }

  openZoomDialog(templateRef: TemplateRef<any>): void {
    this.dialog.open(templateRef, {
      maxWidth: '90vw',
      maxHeight: '90vh',
      ariaLabel: 'Image preview',
      role: 'dialog',
      autoFocus: false,
    });
  }
}
